const cartPopupElem = document.querySelector('.cart-popup');
// **********************************************************
// update cart count in header
// **********************************************************
const updateCartNumber = (number) => {
  const cartIconEl = document.querySelectorAll('.header-main__cart');
  cartIconEl.forEach((item) => {
    const cartIconNumberEl = item.querySelector('.header-main__icon-items');
    if (cartIconNumberEl) {
      if (number === 0) {
        cartIconNumberEl.remove();
      } else {
        cartIconNumberEl.innerHTML = `<p>${number}</p>`;
      }
    } else {
      if (number !== 0) {
        const cartIconNumberElNew = document.createElement('div');
        cartIconNumberElNew.classList.add('header-main__icon-items');
        cartIconNumberElNew.innerHTML = `<p>${number}</p>`;
        item.appendChild(cartIconNumberElNew);
        setIconAnimation(item);
      }
    }
  });
};

const setIconAnimation = (item) => {
  const icon = item.closest('a');
  if (icon) {
    icon.classList.add('is-active');
    setTimeout(() => {
      icon.classList.remove('is-active');
    }, 250);
  }
};

if (cartPopupElem) {
  // **********************************************************
  // Open Cart Popup
  // **********************************************************

  attachEvent('.cart-popup-trigger', 'click', (ev) => {
    const cartPopup = document.querySelector('.cart-popup');
    if (!document.querySelector('.purchase-process')) {
      if (cartPopup) {
        const isOpen = cartPopup.classList.contains('is-cart-open');
        cartPopup.classList.toggle('is-cart-open', !isOpen);
        // GA4 view_cart
        if (!isOpen) window.prowDL.viewCart(cartPopup);
        toggleBodyScrollLock(!isOpen);
      }
      ev.preventDefault();
    }
  });

  // **********************************************************
  // Close Popup When Escape Key Press
  // **********************************************************

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const cartPopupEle = document.querySelectorAll('.cart-popup');
      if (cartPopupEle.length > 0) {
        cartPopupEle.forEach((el) => {
          el.classList.remove('is-cart-open');
          toggleBodyScrollLock(false);
        });
      }
    }
  });

  // **********************************************************
  // Close Popup When Click On Outside
  // **********************************************************

  attachEvent('.cart-popup__overlay, .cart-popup__close', 'click', (ev) => {
    const parentEle = ev.target.closest('.cart-popup');
    parentEle.classList.remove('is-cart-open');
    ev.preventDefault();
    toggleBodyScrollLock(false);
  });

  // **********************************************************
  // Change Item Quantity In Popup Cart
  // **********************************************************
  // Axios add/remove item quantity from cart
  const axiosChangeQuantityInCart = async (newAmountData, source) => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'changeItemQuantityInCart');
    formDataInput.append('inputs', JSON.stringify(newAmountData));
    formDataInput.append('id', localData.id);
    formDataInput.append('source', source);
    formDataInput.append(
      'current',
      document.querySelector('.free-shipping-indicator__progress-bar-inner')?.style.width,
    );
    const currentValue =
      document.querySelector('.cart-module__amount-row-right')?.innerHTML.trim() ||
      document.querySelector('.cart-popup__total-row input')?.value.trim() ||
      0;

    try {
      const response = await axios.post(localData.apiURL, formDataInput);
      updateCartOnChange(response.data.data.cart_content_html, source);
      updateCartNumber(response.data.data.cart_contents_count);
      document
        .querySelector('.cart-popup')
        .classList.toggle('cart-popup--empty', !response.data.data.cart_contents_count);
      inputFocus();
      const headerIcon = document.querySelectorAll('.header-main__heart .header-main__icon-items');
      const data = response.data.data.like;
      headerIcon.forEach((i) => {
        i.innerHTML = `<p>${data.wishlistCount}</p>`;
        i.style.display = data.wishlistCount ? 'flex' : 'none';
        if (data.wishlistCount) {
          setIconAnimation(i);
        }
      });
      if (data.liked) {
        const productCards = document.querySelectorAll('.product-card');
        productCards.forEach((item) => {
          if (data.liked.includes(item.dataset.productId)) {
            item.querySelector('button').classList.add('is-active');
          }
        });
        const productDetail = document.querySelectorAll('.product-id');
        productDetail.forEach((item) => {
          if (item.value && data.liked.includes(item.value) && item.closest('.container')) {
            item.closest('.container').querySelector('.wishlist-button').classList.add('is-active');
          }
        });
      }
      setTimeout(() => {
        const progressBars = document.querySelectorAll('.free-shipping-indicator__progress-bar');
        progressBars.forEach((bar) => {
          const inner = bar.querySelector('.free-shipping-indicator__progress-bar-inner');
          if (inner && bar.dataset.end) {
            inner.style.width = `${bar.dataset.end}%`;
          }
        });
      }, 20);
      if (Object.keys(newAmountData).length !== 0) {
        animateNumbersValue(currentValue);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Change Item Quantity Debounce
  const debouncePopupAxios = (func, timeout = 300) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), timeout);
    };
  };

  const debounceAxiosChangeQuantityInCart = debouncePopupAxios((newAmountData, source) =>
    axiosChangeQuantityInCart(newAmountData, source),
  );

  const hasWordPressLoginCookie = document.cookie.split(';').some((cookie) => {
    const name = cookie.trim().split('=')[0];
    return (
      name.startsWith('wordpress_logged_in_') ||
      name.startsWith('woocommerce_cart_hash') ||
      name.startsWith('wp-settings-time-') ||
      name.startsWith('wordpress_test_cookie') ||
      name.startsWith('wp_woocommerce_session_')
    );
  });

  // click on add/remove item quantity button
  attachEvent('.quantity-counter__button--remove:not(.is-disabled), .quantity-counter__button--add', 'click', (ev) => {
    setTimeout(() => {
      if (!ev.target.closest('.cart-view__item')) {
        return;
      }
      const newAmountData = {
        cart_item_key: ev.target.closest('.cart-view__item').querySelector('.cart-item-key').value,
        quantity: ev.target.closest('.quantity-counter').querySelector('.quantity-counter__input').value,
      };
      const source = ev.target.closest('.cart-popup') ? 'popup' : 'cartPage';
      debounceAxiosChangeQuantityInCart(newAmountData, source);
    }, 10);
  });

  if (!document.querySelector('header.header-main--purchase-process')) {
    if (document.querySelector('.sc-cart-module')) {
      axiosChangeQuantityInCart({}, 'cartPage');
      document.querySelector('.cart-popup-trigger').style.pointerEvents = 'none';
    } else {
      if (
        (Cookies.get('wishlist_items') && Cookies.get('wishlist_items').replace('[]', '')) ||
        hasWordPressLoginCookie
      ) {
        axiosChangeQuantityInCart({}, 'popup');
      }
    }
  }
}
